import {
  typeGetBPUserHomeDataSuccess,
  typeGetBPUserSettingsSuccess,
  typeBuyUserLandAssetSuccess,
  typeGetUserLandAssetsSuccess,
  typeGetUserLandAssetTransactionSuccess,
  typeGetIndividualUserLandAssetsSuccess,
// ===================================================
  typeGetBPAdminHomeDataSuccess,
  typeGetBPAdminSettingsSuccess,
  typeUpdateBPSettingsSuccess,
  typeGetLandAssetsSuccess,
  typeAddLandAssetsSuccess,
  typeGetLandAssetsTransactionsSuccess,
} from '../../interfaces/bit-plot'

export const GET_BP_USER_HOME_DATA = 'GET_BP_USER_HOME_DATA'
export const GET_BP_USER_HOME_DATA_SUCCESS = 'GET_BP_USER_HOME_DATA_SUCCESS'
export const GET_BP_USER_HOME_DATA_FAILED = 'GET_BP_USER_HOME_DATA_FAILED'

export const GET_BP_USER_SETTINGS = 'GET_BP_USER_SETTINGS'
export const GET_BP_USER_SETTINGS_SUCCESS = 'GET_BP_USER_SETTINGS_SUCCESS'
export const GET_BP_USER_SETTINGS_FAILED = 'GET_BP_USER_SETTINGS_FAILED'

export const BUY_LAND_ASSET = 'BUY_LAND_ASSET'
export const BUY_LAND_ASSET_SUCCESS = 'BUY_LAND_ASSET_SUCCESS'
export const BUY_LAND_ASSET_FAILED = 'BUY_LAND_ASSET_FAILED'

export const GET_USER_LAND_ASSETS = 'GET_USER_LAND_ASSETS'
export const GET_USER_LAND_ASSETS_SUCCESS = 'GET_USER_LAND_ASSETS_SUCCESS'
export const GET_USER_LAND_ASSETS_FAILED = 'GET_USER_LAND_ASSETS_FAILED'

export const GET_INDIVIDUAL_USER_LAND_ASSETS = 'GET_INDIVIDUAL_USER_LAND_ASSETS'
export const GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS = 'GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS'
export const GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED = 'GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED'

export const GET_USER_LAND_ASSET_TRANSACTION = 'GET_USER_LAND_ASSET_TRANSACTION'
export const GET_USER_LAND_ASSET_TRANSACTION_SUCCESS = 'GET_USER_LAND_ASSET_TRANSACTION_SUCCESS'
export const GET_USER_LAND_ASSET_TRANSACTION_FAILED = 'GET_USER_LAND_ASSET_TRANSACTION_FAILED'

// =========================================================================================

export const GET_BP_ADMIN_HOME_DATA = 'GET_BP_ADMIN_HOME_DATA'
export const GET_BP_ADMIN_HOME_DATA_SUCCESS = 'GET_BP_ADMIN_HOME_DATA_SUCCESS'
export const GET_BP_ADMIN_HOME_DATA_FAILED = 'GET_BP_ADMIN_HOME_DATA_FAILED'

export const GET_BP_ADMIN_SETTINGS = 'GET_BP_ADMIN_SETTINGS'
export const GET_BP_ADMIN_SETTINGS_SUCCESS = 'GET_BP_ADMIN_SETTINGS_SUCCESS'
export const GET_BP_ADMIN_SETTINGS_FAILED = 'GET_BP_ADMIN_SETTINGS_FAILED'

export const UPDATE_BP_SETTINGS = 'UPDATE_BP_SETTINGS'
export const UPDATE_BP_SETTINGS_SUCCESS = 'UPDATE_BP_SETTINGS_SUCCESS'
export const UPDATE_BP_SETTINGS_FAILED = 'UPDATE_BP_SETTINGS_FAILED'

export const GET_LAND_ASSETS = 'GET_LAND_ASSETS'
export const GET_LAND_ASSETS_SUCCESS = 'GET_LAND_ASSETS_SUCCESS'
export const GET_LAND_ASSETS_FAILED = 'GET_LAND_ASSETS_FAILED'

export const ADD_LAND_ASSETS = 'ADD_LAND_ASSETS'
export const ADD_LAND_ASSETS_SUCCESS = 'ADD_LAND_ASSETS_SUCCESS'
export const ADD_LAND_ASSETS_FAILED = 'ADD_LAND_ASSETS_FAILED'

export const GET_LAND_ASSET_TRANSACTIONS = 'GET_LAND_ASSET_TRANSACTIONS'
export const GET_LAND_ASSET_TRANSACTIONS_SUCCESS = 'GET_LAND_ASSET_TRANSACTIONS_SUCCESS'
export const GET_LAND_ASSET_TRANSACTIONS_FAILED = 'GET_LAND_ASSET_TRANSACTIONS_FAILED'


export interface GetBPUserHomeData {
  type: typeof GET_BP_USER_HOME_DATA
}
export interface GetBPUserHomeDataSuccess {
  type: typeof GET_BP_USER_HOME_DATA_SUCCESS
  payload: typeGetBPUserHomeDataSuccess
}
export interface GetBPUserHomeDataFailed {
  type: typeof GET_BP_USER_HOME_DATA_FAILED
  payload: any
}
export interface GetBPUserSettings {
  type: typeof GET_BP_USER_SETTINGS
}
export interface GetBPUserSettingsSuccess {
  type: typeof GET_BP_USER_SETTINGS_SUCCESS
  payload: typeGetBPUserSettingsSuccess
}
export interface GetBPUserSettingsFailed {
  type: typeof GET_BP_USER_SETTINGS_FAILED
  payload: any
}
export interface BuyUserLandAsset {
  type: typeof BUY_LAND_ASSET
}
export interface BuyUserLandAssetSuccess {
  type: typeof BUY_LAND_ASSET_SUCCESS
  payload: typeBuyUserLandAssetSuccess
}
export interface BuyUserLandAssetFailed {
  type: typeof BUY_LAND_ASSET_FAILED
  payload: any
}

export interface GetUserLandAssets {
  type: typeof GET_USER_LAND_ASSETS
}
export interface GetUserLandAssetsSuccess {
  type: typeof GET_USER_LAND_ASSETS_SUCCESS
  payload: typeGetUserLandAssetsSuccess
}
export interface GetUserLandAssetsFailed {
  type: typeof GET_USER_LAND_ASSETS_FAILED
  payload: any
}

export interface GetIndividualUserLandAssets {
  type: typeof GET_INDIVIDUAL_USER_LAND_ASSETS
}
export interface GetIndividualUserLandAssetsSuccess {
  type: typeof GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS
  payload: typeGetIndividualUserLandAssetsSuccess
}
export interface GetIndividualUserLandAssetsFailed {
  type: typeof GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED
  payload: any
}

export interface GetUserLandAssetTransaction {
  type: typeof GET_USER_LAND_ASSET_TRANSACTION
}
export interface GetUserLandAssetTransactionSuccess {
  type: typeof GET_USER_LAND_ASSET_TRANSACTION_SUCCESS
  payload: typeGetUserLandAssetTransactionSuccess
}
export interface GetUserLandAssetTransactionFailed {
  type: typeof GET_USER_LAND_ASSET_TRANSACTION_FAILED
  payload: any
}

// ====================================================
export interface GetBPAdminHomeData {
  type: typeof GET_BP_ADMIN_HOME_DATA
}
export interface GetBPAdminHomeDataSuccess {
  type: typeof GET_BP_ADMIN_HOME_DATA_SUCCESS
  payload: typeGetBPAdminHomeDataSuccess
}
export interface GetBPAdminHomeDataFailed {
  type: typeof GET_BP_ADMIN_HOME_DATA_FAILED
  payload: any
}
export interface GetBPAdminSettings {
  type: typeof GET_BP_ADMIN_SETTINGS
}
export interface GetBPAdminSettingsSuccess {
  type: typeof GET_BP_ADMIN_SETTINGS_SUCCESS
  payload: typeGetBPAdminSettingsSuccess
}
export interface GetBPAdminSettingsFailed {
  type: typeof GET_BP_ADMIN_SETTINGS_FAILED
  payload: any
}
export interface UpdateBPSettings {
  type: typeof UPDATE_BP_SETTINGS
}
export interface UpdateBPSettingsSuccess {
  type: typeof UPDATE_BP_SETTINGS_SUCCESS
  payload: typeUpdateBPSettingsSuccess
}
export interface UpdateBPSettingsFailed {
  type: typeof UPDATE_BP_SETTINGS_FAILED
  payload: any
}

export interface GetLandAssets {
  type: typeof GET_LAND_ASSETS
}
export interface GetLandAssetsSuccess {
  type: typeof GET_LAND_ASSETS_SUCCESS
  payload: typeGetLandAssetsSuccess
}
export interface GetLandAssetsFailed {
  type: typeof GET_LAND_ASSETS_FAILED
  payload: any
}

export interface AddLandAssets {
  type: typeof ADD_LAND_ASSETS
}
export interface AddLandAssetsSuccess {
  type: typeof ADD_LAND_ASSETS_SUCCESS
  payload: typeAddLandAssetsSuccess
}
export interface AddLandAssetsFailed {
  type: typeof ADD_LAND_ASSETS_FAILED
  payload: any
}

export interface GetLandAssetsTransactions {
  type: typeof GET_LAND_ASSET_TRANSACTIONS
}
export interface GetLandAssetsTransactionsSuccess {
  type: typeof GET_LAND_ASSET_TRANSACTIONS_SUCCESS
  payload: typeGetLandAssetsTransactionsSuccess
}
export interface GetLandAssetsTransactionsFailed {
  type: typeof GET_LAND_ASSET_TRANSACTIONS_FAILED
  payload: any
}

export type BitplotActionConstants =
  | GetBPUserHomeData
  | GetBPUserHomeDataSuccess
  | GetBPUserHomeDataFailed
  | GetBPUserSettings
  | GetBPUserSettingsSuccess
  | GetBPUserSettingsFailed
  | GetUserLandAssets
  | GetUserLandAssetsSuccess
  | GetUserLandAssetsFailed
  | BuyUserLandAsset
  | BuyUserLandAssetSuccess
  | BuyUserLandAssetFailed
  | GetUserLandAssetTransaction
  | GetUserLandAssetTransactionSuccess
  | GetUserLandAssetTransactionFailed
  | GetBPAdminHomeData
  | GetBPAdminHomeDataSuccess
  | GetBPAdminHomeDataFailed
  | GetBPAdminSettings
  | GetBPAdminSettingsSuccess
  | GetBPAdminSettingsFailed
  | GetLandAssets
  | GetLandAssetsSuccess
  | GetLandAssetsFailed
  | UpdateBPSettings
  | UpdateBPSettingsSuccess
  | UpdateBPSettingsFailed
  | AddLandAssets
  | AddLandAssetsSuccess
  | AddLandAssetsFailed
  | GetLandAssetsTransactions
  | GetLandAssetsTransactionsSuccess
  | GetLandAssetsTransactionsFailed
  | GetIndividualUserLandAssets
  | GetIndividualUserLandAssetsSuccess
  | GetIndividualUserLandAssetsFailed